import { LastName } from '@dreryk/person-name-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

type LastNameFieldProps = FieldControllerProps<'lastName', string | null>;

export const LastNameField = (props: LastNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register(props.name, {
            required: props.required,
            maxLength: LastName.MAX_LENGTH,
         })}
         label={commonTranslationKeys.lastName}
         testId={props.name}
         defaultValue={props.defaultValue}
      />
   );
};
